import {gsap} from "gsap";

window.addEventListener('DOMContentLoaded', (event) => {

    // animation for team cards on about us page
    if( document.body.classList.contains('about-us') ) {
        const cards = document.querySelectorAll('.team-card');
        if(cards) {
            cards.forEach((card, i) => {
                if( i % 3 === 0 ) {
                    card.classList.add('animate');
                }
                if( i % 3 === 1 ) {
                    card.classList.add('animate','delay-1');
                }
                if( i % 3 === 2 ) {
                    card.classList.add('animate','delay-2');
                }
            });
        }
    }

    const elements = document.querySelectorAll('.animate');
    const animationDuration = 0.25; // seconds
    
    elements.forEach(element => {
        gsap.to(element, {
            scrollTrigger: {
                trigger: element,
                start: "20px bottom"
            },
            visibility: 'visible',
            opacity: 1,
            duration: animationDuration
        })
    });
});